import {
  APP_LEGAL_PAGE_IMPRINT,
  APP_LEGAL_PAGE_DISPOSAL_AND_ENV,
  APP_LEGAL_PAGE_TERMS_AND_CONDITIONS,
  APP_LEGAL_PAGE_PRIVACY_POLICY,
  APP_LEGAL_PAGE_ABOUT,
} from './routes.constants';

export const LEGAL_PAGES_MAP = {
  imprint: APP_LEGAL_PAGE_IMPRINT,
  disposalAndEnv: APP_LEGAL_PAGE_DISPOSAL_AND_ENV,
  aboutUs: APP_LEGAL_PAGE_ABOUT,
  termsAndPurchase: APP_LEGAL_PAGE_TERMS_AND_CONDITIONS,
  privacyPolicy: APP_LEGAL_PAGE_PRIVACY_POLICY,
};
